module.exports = __webpack_public_path__ + "public/img/Desktop-2.05e23a38.png";